import React from 'react'
import { reduxForm, Field, formValueSelector, InjectedFormProps } from 'redux-form'
import { connect } from 'react-redux'
import { useSelector } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { FormButtons, renderers, validations } from '../../../../components'
import '../style.css'

import { ContactDetailsFields } from './ContactDetailsFields'
import { EmailFieldWithDomainSuggestions } from './EmailFieldWithDomainSuggestions'
import { CategorySelector } from './CategorySelector'
import { TermsWithSlider } from './TermsWithSlider'
import { RootState } from '../../../../state/reducer'

// ---------- Constants ----------
const FORM_NAME = 'token-entry-form'

// ---------- Form Data Types ----------
interface FormData {
  email?: string
  category?: string
}

interface StateProps {
  email?: string
  category?: string
}

// Props passed to the form component
type Props = InjectedFormProps<FormData, StateProps> & StateProps

// ---------- Component ----------
const TokenEntryFormHTML: React.FC<Props> = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  email,
  category,
}) => {
  const { clientName } = useSelector((state: RootState) => state.application)

  return (
    <form onSubmit={handleSubmit}>
      <ContactDetailsFields />

      <Row>
        <Col xs={12}>
          <EmailFieldWithDomainSuggestions email={email} />
        </Col>
      </Row>

      <CategorySelector selected={category} />

      <div style={{ visibility: 'hidden', maxHeight: '1px' }}>
        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={[validations.required]}
          name="category"
          label="What do you need help with?"
        />
      </div>

      <TermsWithSlider clientName={clientName} />
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

// ---------- Selector ----------
const selector = formValueSelector<FormData>(FORM_NAME)


// @ts-ignore
const mapStateToProps = (state: RootState&{email:string}): StateProps => ({
  email: selector(state, 'email') as string | undefined,
  category: selector(state, 'category') as string | undefined,
})
// ---------- Compose and Export ----------
export const TokenEntryForm =  connect(mapStateToProps)(
  reduxForm<FormData, StateProps>({
    form: FORM_NAME,
  })(TokenEntryFormHTML)
)
